import {
  Invitation,
  Inviter,
  Registerer,
  RegistererState,
  SessionState,
  SIPExtension,
  TransportState,
  UserAgent,
  UserAgentState,
  Web,
  version,
} from 'sip.js';

window.SIP_NEXT_MODERN = Object.freeze({
  Invitation,
  Inviter,
  Registerer,
  RegistererState,
  SessionState,
  SIPExtension,
  TransportState,
  UserAgent,
  UserAgentState,
  Web,
  packageVersion: '0.21.2',
  version,
});
